import type { RouteRecordRaw } from "vue-router";
import Layout from "@/views/layouts/index.vue";

const userMessageRouters: RouteRecordRaw[] = [
    {
        path: "/userMessage",
        name: "UserMessage",
        meta: { title: "消息" },
        component: Layout,
        redirect: "/userMessage/",
        children: [
            {
                path: "/userMessage/",
                name: "UserMessageIndex",
                meta: { title: "我的消息", hideMenu: true },
                component: () => import("@/views/pages/userMessage/index.vue")
            },
            {
                path: "notification",
                name: "UserMessageNotificationDetail",
                meta: { title: "通知详情", hideMenu: true },
                component: () => import("@/views/pages/userMessage/notification/index.vue")
            }
        ]
    }
];

export default userMessageRouters;
